export const GUEST_USER_IDENTIFIER = 'zso_guest';
export const GUEST_USER_PASSWORD = 'zsogast';
export const GUEST_USER_ORG = 'ZSO Gast';
export const ALLOW_OFFLINE_ACCESS_KEY = 'zskarte_allow_offline_access';
